// extracted by mini-css-extract-plugin
export default {"draft-panel":"lsf-draft-panel","draft-panel__toggle":"lsf-draft-panel__toggle","waiting":"lsf-waiting"};
    if(module.hot) {
      // 1653630380651
      var cssReload = require("/home/runner/work/label-studio-frontend/label-studio-frontend/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  